import { ulid } from 'ulid';

interface LimitPolicyCloneInput {
  name: string;
  priority: number;
  isActive: boolean;
  scenarioId?: string | null;
  scenarioLabel?: string | null;
  limit?: {
    minAmount?: number;
    maxAmount?: number;
    minStayMinutes?: number;
    maxStayMinutes?: number;
  };
  billingCycleId?: number;
}

export interface ClonedLimitPolicyData {
  limitPolicyId: string;
  name: string;
  priority: number;
  isActive: boolean;
  scenarioId?: string | null;
  scenarioLabel?: string | null;
  limit?: {
    minAmount?: number;
    maxAmount?: number;
    minStayMinutes?: number;
    maxStayMinutes?: number;
  };
  billingCycleId?: number;
}

/**
 * Clone a LimitPolicy entity
 *
 * - limitPolicyId: NEW (regenerated)
 * - facilityId: Handled server-side (not included in CreateLimitPolicyInput)
 * - scenarioId: PRESERVED (foreign key - the policy references the same scenario)
 * - limit: COPIED as inline object (no longer a foreign key reference)
 * - billingCycleId: PRESERVED (lookup reference)
 * - All other fields: COPIED as-is
 */
export function cloneLimitPolicy(source: LimitPolicyCloneInput): ClonedLimitPolicyData {
  return {
    limitPolicyId: ulid(),
    name: `${source.name} (Copy)`,
    scenarioId: source.scenarioId,
    scenarioLabel: source.scenarioLabel,
    limit: source.limit,
    billingCycleId: source.billingCycleId,
    priority: source.priority,
    isActive: source.isActive,
  };
}
